const randomizeArray = (arr: string[]): string[] => {
  return arr.sort(() => Math.random() - 0.5)
}

const SOCIAL_MEDIAS = 'Redes Sociais'
const OTHERS = 'Outros (especifique)'

const getRandomizesFindOutAlice = () => {
  const inputArray = [
    'Pesquisa Google',
    'Eventos',
    'Artigos ou notícias',
    'Sigo / conheço alguém da Alice',
    'Indicação de amigos / conhecidos',
    'Já conhecia a marca / conhecimento prévio',
    SOCIAL_MEDIAS
  ]

  const randomizedArray = randomizeArray(inputArray)
  randomizedArray.push(OTHERS)

  return randomizedArray
}

const getRandomizesSocialMedias = () => {
  const inputArray = ['LinkedIn', 'Instagram', 'YouTube', 'Facebook']

  const randomizedArray = randomizeArray(inputArray)
  randomizedArray.push('Outra')

  return randomizedArray
}

export {
  getRandomizesFindOutAlice,
  getRandomizesSocialMedias,
  SOCIAL_MEDIAS,
  OTHERS
}
